import { HierarchyNode } from '@app/core/models/data-dictionary.model';

/** Resolves export checkbox selections to dictionary ids (tables only, not folders). */
export function collectDictionaryIdsFromHierarchy(
  hierarchy: HierarchyNode[],
  selectedIds: number[],
): number[] {
  const dictionaryIds: number[] = [];

  const findDictionary = (nodes: HierarchyNode[], targetId: number): boolean => {
    for (const node of nodes) {
      if (node.id === targetId && node.type === 'dictionary') {
        dictionaryIds.push(node.id);
        return true;
      }
      if (node.children && findDictionary(node.children, targetId)) {
        return true;
      }
    }
    return false;
  };

  selectedIds.forEach((id) => findDictionary(hierarchy, id));
  return [...new Set(dictionaryIds)];
}
